import { type AddressOrNative, NATIVE_TOKEN_IDENTIFIER } from '@cronos-app/sdk';
import { useNormalTokenConfig } from '@ui/config/token';
import { Token } from '@ui/config/token/types';
import { useBondingTokenConfig } from '@ui/hooks/contracts/useBondingTokenConfig';
import { useMemo } from 'react';

import { useAgentTokenConfig } from './useAgentTokenConfig';

export const useTokenConfig = (options: {
  token: Token;
  tokenAddress: AddressOrNative | undefined;
}) => {
  const tokenConfig = useNormalTokenConfig();
  const bondingTokenConfig = useBondingTokenConfig({
    tokenAddress:
      options.token === Token.Bonding &&
      options.tokenAddress !== NATIVE_TOKEN_IDENTIFIER
        ? options.tokenAddress
        : undefined,
  }).data;

  const agentTokenConfig = useAgentTokenConfig({
    tokenAddress:
      options.token === Token.Agent &&
      options.tokenAddress !== NATIVE_TOKEN_IDENTIFIER
        ? options.tokenAddress
        : undefined,
  }).data;

  return useMemo(() => {
    if (options.token === Token.Bonding) return bondingTokenConfig;
    if (options.token === Token.Agent) return agentTokenConfig;
    return tokenConfig[options.token];
  }, [options.token, bondingTokenConfig, agentTokenConfig, tokenConfig]);
};
